import { fetchApi, postApi, putApi, deleteApi, FH_ADMIN_API } from '@/api/client'
import type {
  PersonalizedMapping,
  CreatePersonalizedMappingRequest,
  UpdatePersonalizedMappingRequest,
} from '../types'

const BASE = `${FH_ADMIN_API}/personalized-mappings`

export async function listPersonalizedMappings(accId: number): Promise<PersonalizedMapping[]> {
  return fetchApi<PersonalizedMapping[]>(`${BASE}/account/${accId}`)
}

export async function getPersonalizedMapping(id: string): Promise<PersonalizedMapping> {
  return fetchApi<PersonalizedMapping>(`${BASE}/${id}`)
}

export async function createPersonalizedMapping(
  data: CreatePersonalizedMappingRequest,
): Promise<PersonalizedMapping> {
  return postApi<PersonalizedMapping>(BASE, data)
}

export async function updatePersonalizedMapping(
  id: string,
  data: UpdatePersonalizedMappingRequest,
): Promise<PersonalizedMapping> {
  return putApi<PersonalizedMapping>(`${BASE}/${id}`, data)
}

export async function deletePersonalizedMapping(id: string): Promise<void> {
  return deleteApi<void>(`${BASE}/${id}`)
}
